module.exports = __webpack_public_path__ + "static/media/fetchInvites.8ccdab31.graphql";